import { NavLink } from "react-router-dom";
import HeaderImage from "../assets/images/Usage Analytics.png";

const Home: React.FC = () => {
  return (
    <header className="flex flex-col h-screen overflow-x-hidden font-dm-sans">
      <nav className="border-b">
        <div className="container flex items-center justify-between px-4 py-6 mx-auto">
          <div className="flex items-center space-x-4">
            <span className="p-2 text-white lg:p-2.5 rounded-lg bg-primary">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_23_760)">
                  <path
                    d="M7.38333 8.51667C8.2854 8.51667 9.01667 7.7854 9.01667 6.88333C9.01667 5.98127 8.2854 5.25 7.38333 5.25C6.48127 5.25 5.75 5.98127 5.75 6.88333C5.75 7.7854 6.48127 8.51667 7.38333 8.51667Z"
                    stroke="white"
                    strokeWidth="1.225"
                    strokeLinecap="round"
                  />
                  <path
                    d="M11.4122 8.51675C11.3397 8.68097 11.3181 8.86313 11.3501 9.03974C11.3821 9.21636 11.4663 9.37933 11.5919 9.50764L11.6245 9.54031C11.7258 9.64144 11.8061 9.76153 11.8609 9.89372C11.9157 10.0259 11.9439 10.1676 11.9439 10.3107C11.9439 10.4538 11.9157 10.5955 11.8609 10.7277C11.8061 10.8599 11.7258 10.98 11.6245 11.0811C11.5234 11.1823 11.4033 11.2626 11.2711 11.3174C11.1389 11.3722 10.9972 11.4004 10.8541 11.4004C10.711 11.4004 10.5693 11.3722 10.4372 11.3174C10.305 11.2626 10.1849 11.1823 10.0837 11.0811L10.0511 11.0484C9.92276 10.9229 9.75979 10.8387 9.58317 10.8067C9.40656 10.7747 9.2244 10.7963 9.06019 10.8688C8.89916 10.9378 8.76182 11.0524 8.66509 11.1984C8.56835 11.3445 8.51644 11.5157 8.51574 11.6909V11.7834C8.51574 12.0722 8.40102 12.3492 8.19681 12.5534C7.99261 12.7576 7.71564 12.8723 7.42685 12.8723C7.13806 12.8723 6.8611 12.7576 6.65689 12.5534C6.45269 12.3492 6.33796 12.0722 6.33796 11.7834V11.7344C6.33375 11.5542 6.27542 11.3794 6.17055 11.2328C6.06569 11.0862 5.91914 10.9745 5.74996 10.9123C5.58575 10.8398 5.40359 10.8182 5.22698 10.8502C5.05036 10.8823 4.88739 10.9665 4.75908 11.092L4.72641 11.1246C4.62528 11.2259 4.50519 11.3062 4.373 11.361C4.24081 11.4158 4.09912 11.444 3.95602 11.444C3.81292 11.444 3.67123 11.4158 3.53904 11.361C3.40685 11.3062 3.28676 11.2259 3.18563 11.1246C3.08439 11.0235 3.00408 10.9034 2.94928 10.7712C2.89448 10.639 2.86627 10.4974 2.86627 10.3543C2.86627 10.2112 2.89448 10.0695 2.94928 9.93727C3.00408 9.80508 3.08439 9.68499 3.18563 9.58386L3.2183 9.5512C3.34381 9.42288 3.42801 9.25991 3.46003 9.0833C3.49206 8.90668 3.47044 8.72452 3.39796 8.56031C3.32895 8.39928 3.21435 8.26194 3.06828 8.16521C2.92222 8.06848 2.75105 8.01656 2.57585 8.01586H2.4833C2.19451 8.01586 1.91754 7.90114 1.71334 7.69694C1.50913 7.49273 1.39441 7.21577 1.39441 6.92698C1.39441 6.63818 1.50913 6.36122 1.71334 6.15702C1.91754 5.95281 2.19451 5.83809 2.4833 5.83809H2.5323C2.71251 5.83387 2.88728 5.77554 3.03389 5.67068C3.18051 5.56581 3.29219 5.41926 3.35441 5.25009C3.42688 5.08587 3.4485 4.90371 3.41648 4.7271C3.38445 4.55048 3.30026 4.38751 3.17474 4.2592L3.14208 4.22653C3.04083 4.1254 2.96052 4.00531 2.90572 3.87312C2.85092 3.74093 2.82272 3.59924 2.82272 3.45614C2.82272 3.31305 2.85092 3.17135 2.90572 3.03916C2.96052 2.90697 3.04083 2.78688 3.14208 2.68575C3.2432 2.58451 3.3633 2.5042 3.49549 2.4494C3.62767 2.3946 3.76937 2.3664 3.91246 2.3664C4.05556 2.3664 4.19726 2.3946 4.32944 2.4494C4.46163 2.5042 4.58173 2.58451 4.68285 2.68575L4.71552 2.71842C4.84383 2.84393 5.00681 2.92813 5.18342 2.96016C5.36004 2.99218 5.5422 2.97056 5.70641 2.89809H5.74996C5.91099 2.82907 6.04833 2.71448 6.14506 2.56841C6.2418 2.42234 6.29371 2.25117 6.29441 2.07598V1.98342C6.29441 1.69463 6.40913 1.41767 6.61334 1.21346C6.81754 1.00925 7.09451 0.894531 7.3833 0.894531C7.67209 0.894531 7.94905 1.00925 8.15326 1.21346C8.35746 1.41767 8.47219 1.69463 8.47219 1.98342V2.03242C8.47289 2.20761 8.5248 2.37878 8.62153 2.52485C8.71827 2.67092 8.8556 2.78552 9.01663 2.85453C9.18084 2.92701 9.363 2.94862 9.53962 2.9166C9.71623 2.88458 9.87921 2.80038 10.0075 2.67486L10.0402 2.6422C10.1413 2.54096 10.2614 2.46064 10.3936 2.40584C10.5258 2.35105 10.6675 2.32284 10.8106 2.32284C10.9537 2.32284 11.0954 2.35105 11.2276 2.40584C11.3597 2.46064 11.4798 2.54096 11.581 2.6422C11.6822 2.74333 11.7625 2.86342 11.8173 2.99561C11.8721 3.1278 11.9003 3.26949 11.9003 3.41259C11.9003 3.55568 11.8721 3.69738 11.8173 3.82957C11.7625 3.96176 11.6822 4.08185 11.581 4.18298L11.5483 4.21564C11.4228 4.34396 11.3386 4.50693 11.3066 4.68354C11.2745 4.86016 11.2962 5.04232 11.3686 5.20653V5.25009C11.4376 5.41112 11.5522 5.54845 11.6983 5.64519C11.8444 5.74192 12.0155 5.79383 12.1907 5.79453H12.2833C12.5721 5.79453 12.8491 5.90925 13.0533 6.11346C13.2575 6.31767 13.3722 6.59463 13.3722 6.88342C13.3722 7.17221 13.2575 7.44917 13.0533 7.65338C12.8491 7.85759 12.5721 7.97231 12.2833 7.97231H12.2343C12.0591 7.97301 11.8879 8.02492 11.7419 8.12165C11.5958 8.21839 11.4812 8.35572 11.4122 8.51675V8.51675Z"
                    stroke="white"
                    strokeWidth="1.225"
                    strokeLinecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_23_760">
                    <rect
                      width="13.0667"
                      height="13.0667"
                      fill="white"
                      transform="translate(0.849976 0.350098)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>

            <h3 className="text-base font-bold text-gray-primary">
              OpenConfig
            </h3>
          </div>

          <NavLink to="/" className="text-sm font-medium text-gray-primary">
            Sign In
          </NavLink>
        </div>
      </nav>

      <section className="flex-1">
        <div className="container h-full px-4 mx-auto space-x-16 xl:flex">
          <div className="flex flex-col py-8 xl:w-1/2 xl:py-0">
            <div className="flex items-center xl:flex-1">
              <div>
                <h1 className="text-4xl font-bold leading-tight md:text-5xl">
                  Be In Control of your <br className="hidden xl:block" /> Apps
                  with <span className=" text-primary">OpenConfig</span>
                </h1>

                <p className="mt-6 text-base md:text-lg text-gray-primary">
                  Oversee your hlth.dev products like OpenScheduling, Patient
                  App & more
                </p>
              </div>
            </div>

            <div className="mt-8 space-y-4 md:flex md:items-end md:pb-20 md:space-y-0 md:space-x-8 ">
              <div className="w-full md:w-1/2">
                <p className="text-lg font-medium text-gray-700">
                  Explore Apps by hlth.dev
                </p>

                <NavLink
                  to="/"
                  className="flex items-center justify-between w-full bg-[#313131] rounded-xl px-6 py-4 hover:bg-[#313131]/90 mt-6"
                >
                  <span className="text-sm font-medium text-white">
                    PatientApp
                  </span>

                  <p className="flex items-center space-x-2 text-white/50">
                    <span className="text-sm ">Explore Now</span>

                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.66666 11.3334L11.3333 4.66675"
                        stroke="currentColor"
                        strokeLinecap="round"
                      />
                      <path
                        d="M4.66666 4.66675H11.3333V11.3334"
                        stroke="currentColor"
                        strokeLinecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>

              <div className="flex flex-col w-full md:w-1/2">
                <p className="flex items-center order-2 mt-4 space-x-3 text-sm md:mt-0 md:order-1 md:justify-end text-primary">
                  <span>Hlth.dev Accelerators Ecosystem</span>

                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 5.71404H10.4281"
                      stroke="#546CCC"
                      strokeLinecap="round"
                    />
                    <path
                      d="M5.71404 1L10.4281 5.71404L5.71404 10.4281"
                      stroke="#546CCC"
                      strokeLinecap="round"
                    />
                  </svg>
                </p>

                <NavLink
                  to="/"
                  className="flex order-1 items-center md:order-2 md:mt-6 justify-between w-full bg-[#313131] rounded-xl px-6 py-4 hover:bg-[#313131]/90"
                >
                  <span className="text-sm font-medium text-white">
                    OpenScheduling
                  </span>

                  <p className="flex items-center space-x-2 text-white/50">
                    <span className="text-sm ">Explore Now</span>

                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.66666 11.3334L11.3333 4.66675"
                        stroke="currentColor"
                        strokeLinecap="round"
                      />
                      <path
                        d="M4.66666 4.66675H11.3333V11.3334"
                        stroke="currentColor"
                        strokeLinecap="round"
                      />
                    </svg>
                  </p>
                </NavLink>
              </div>
            </div>
          </div>

          <div className="w-full xl:w-1/2">
            <img
              className="mx-auto border-2 border-gray-100 rounded-lg lg:rounded-none lg:rounded-l-lg lg:absolute xl:bottom-0 lg:-bottom-8 lg:right-0 lg:max-w-md xl:max-w-2xl lg:mt-0"
              src={HeaderImage}
              alt=""
            />
          </div>
        </div>
      </section>
    </header>
  );
};

export default Home;
